export enum RestrictionInvalidityReason {
    RESTRICTION_MIN_ORDER_AMOUNT_NOT_REACHED = "restriction_min_order_amount_not_reached",
    RESTRICTION_START_DATE_NOT_RESPECTED = "restriction_start_date_not_respected",
    RESTRICTION_END_DATE_NOT_RESPECTED = "restriction_end_date_not_respected",
    RESTRICTION_END_TIME_NOT_RESPECTED = "restriction_end_time_not_respected",
    RESTRICTION_START_TIME_NOT_RESPECTED = "restriction_start_time_not_respected",
    RESTRICTION_DOW_NOT_RESPECTED = "restriction_dow_not_respected",
    RESTRICTION_SERVICE_TYPE_NOT_RESPECTED = "restriction_service_type_not_respected",
    RESTRICTION_TABLE_AREA_NOT_RESPECTED = "restriction_zone_area_not_respected",
}